import { c as _c } from "react/compiler-runtime";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useFetchCompanySubscriptions } from "@hooks/subscription/use-fetch-company-subscriptions";
import { useFetchActiveMembers } from "@hooks/use-fetch-active-members";
import { useMemberSeatsLookup } from "@hooks/use-member-seats-lookup";
import { areActiveMembersLoadingSelector } from "@store/active-members/active-members-selector";
import { fetchingSdbCompanyFlagsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
/**
 * Fetches what it takes to tell which seats the members of the selected workspace hold, see
 * useMemberSeatsLookup, for a page that shows them.
 *
 * The seats are derived from the workspace subscriptions, which are not fetched for everybody when
 * the workspace is loaded. A plan that limits the active users gives a Sphere XG seat to each of
 * them, and only the users that may view the subscription details can read the active members, as
 * in the subscription settings.
 */
export function useFetchMemberSeats() {
  const $ = _c(3);
  useFetchCompanySubscriptions();
  const {
    isUserRolePlan
  } = useMemberSeatsLookup();
  const {
    canViewSubscriptionDetails
  } = useHasUserValidRoleCompanyLevel();
  const shouldFetchActiveMembers = isUserRolePlan && canViewSubscriptionDetails;
  useFetchActiveMembers(shouldFetchActiveMembers);
  const {
    fetchCompanySubscriptions
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const isFetchingCompanySubscriptions = fetchCompanySubscriptions === "pending";
  const isFetchingActiveMembers = useAppSelector(areActiveMembersLoadingSelector);
  const areActiveMembersLoading = shouldFetchActiveMembers && isFetchingActiveMembers;
  const t0 = isFetchingCompanySubscriptions || areActiveMembersLoading;
  let t1;
  if ($[0] !== areActiveMembersLoading || $[1] !== t0) {
    t1 = {
      isLoading: t0,
      areActiveMembersLoading
    };
    $[0] = areActiveMembersLoading;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}